var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{ref:"footer",staticClass:"c2h4-footer__logo"},[_c('img',{staticClass:"c2h4-img__logo",attrs:{"src":_vm.logo,"alt":"你今天真好看APP，轻松拍照测肤质"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a42e26a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/footer/index.vue
// module id = null
// module chunks = 